import { render, staticRenderFns } from "./DataAccessSubscriptionPaymentPopup.vue?vue&type=template&id=5db74b29&scoped=true&"
import script from "./DataAccessSubscriptionPaymentPopup.vue?vue&type=script&lang=js&"
export * from "./DataAccessSubscriptionPaymentPopup.vue?vue&type=script&lang=js&"
import style0 from "./DataAccessSubscriptionPaymentPopup.vue?vue&type=style&index=0&id=5db74b29&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db74b29",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5db74b29')) {
      api.createRecord('5db74b29', component.options)
    } else {
      api.reload('5db74b29', component.options)
    }
    module.hot.accept("./DataAccessSubscriptionPaymentPopup.vue?vue&type=template&id=5db74b29&scoped=true&", function () {
      api.rerender('5db74b29', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Brand/DataAccessSubscriptionPaymentPopup.vue"
export default component.exports